import { creditCardsSelector } from 'credit-cards/selectors'
import { removeCreditCard, setDefaultCreditCard } from 'credit-cards/actions'
import { pendingSelector } from 'api/selectors'
import CreditCard from 'dashboard-credit-cards/components/ListItem'
import ErrorMessage from '@components/ErrorMessage'

const CreditCardList = ({ creditCards = [], removeCreditCard, setDefaultCreditCard, pending }) => {
    const setDefaultCardError = pending.setDefaultCard instanceof Error ? pending.setDefaultCard.message : ''
    const removeCreditCardError = pending.removeCreditCard instanceof Error ? pending.removeCreditCard.message : ''

    const onDeleteClicked = creditCard => event => {
        event.stopPropagation()
        removeCreditCard(creditCard)
    }

    const onSetDefaultClicked = creditCard => () => {
        setDefaultCreditCard(creditCard)
    }

    return (
        <>
            <ul className="cards-list list-with-buttons">
                {creditCards.map(creditCard => (
                    <CreditCard
                        {...creditCard}
                        onDelete={onDeleteClicked(creditCard)}
                        key={creditCard.id}
                        setDefault={onSetDefaultClicked(creditCard)}
                        pending={
                            pending[`removeCreditCard-${creditCard.id}`] === true ||
                            pending[`setDefaultCard-${creditCard.id}`] === true
                        }
                    />
                ))}
                {(setDefaultCardError || removeCreditCardError) && (
                    <ErrorMessage messages={[setDefaultCardError, removeCreditCardError]} />
                )}
            </ul>
        </>
    )
}

const mapStateToProps = createStructuredSelector({
    creditCards: creditCardsSelector,
    pending: pendingSelector,
})

const mapDispatchToProps = {
    removeCreditCard,
    setDefaultCreditCard,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardList)
